import { combineReducers } from "redux";

import users from "./users";
import tags from "./tags";
import specialFeatures from "./specialFeatures";

export default combineReducers({
  users,
  tags,
  specialFeatures,
});
